import React, { useState, useEffect } from 'react';
import { dateFormatConDia, getDate } from '../../../../../utils/DateFunctions';

const RegistroActividadEjecutada = (p) => {
    const { data, dia, dia_numero } = p.data;
    const [cantidad, setcantidad] = useState({ cantidad: 0, charolas: 0, germinacion: 0 });
    const inventarios_charolas = ['EJECUCIÓN DE SIEMBRA POR DÍA', 'INVENTARIO DE VIVERO', 'PROGRAMA DE CONSOLIDACIÓN POR DÍA'];
    const inventarios_germinacion = ['INVENTARIO DE VIVERO', 'PROGRAMA DE CONSOLIDACIÓN POR DÍA'];

    function changeValue(e) {
        const { name, value } = e.target;
        setcantidad({ ...cantidad, [name]: +value });
    }

    async function registrar() {
        if (p.registrar) {
            let dataSend = { ...cantidad, dia: dia_numero, actividad: data.id };
            if (await p.registrar(dataSend) && p.cerrarPadre) p.cerrarPadre();
        }
    }
    return (
        <div className='w-100 m-0 p-1 relative'>
            <div className='col-auto mt-3 me-3' style={{ position: "absolute", top: 0, right: 0, zIndex: 2 }}>
                <button className='btn btn-danger btn-sm round-xxl scale-continue-025 shadow' onClick={p.close} >Cerrar formulario de envio</button>
            </div>
            <div className='row justify-content-center w-100 m-0 p-0'>
                <div className='w-70 border-bottom border-2 mt-3 mb-1'></div>
                <div className='w-100 text-l text-bold text-blue3 mb-3'>
                    Registrar avances
                    <span className='text-s text-black ms-2'>{dateFormatConDia(getDate())}</span>
                </div>
                <div className='bw-300 border-bottom text-xs border-secondary text-center m-1'>Unidad: <span className='text-400 text-s ms-2'>{data.unidad}</span></div>
                <div className='bw-300 border-bottom text-xs border-secondary text-center m-1'>Inventario: <span className='text-400 text-s ms-2'>{data.afecta_inventarios ?? "NO AFECTA INVENTARIOS"}</span></div>
                <div className='bw-300 border-bottom text-xs border-secondary text-center m-1'>
                    {data.unidad} X hora: <span className='text-400 text-m ms-2'>{data.unidad_hora ?? "NO AFECTA INVENTARIOS"}</span>
                </div>
                <div className='w-100 m-0 mb-3 p-0'></div>
                <div className='form-group bw-300 m-2'>
                    <label className='text-bold text-s w-100 text-start'>Cantidad de {data.unidad.toLowerCase()}</label>
                    <input type='number' min={0} className='form-control shadow border' name="cantidad" value={cantidad.cantidad} onChange={changeValue} />
                </div>
                {data.unidad.toLowerCase() != 'charolas' && data.afecta_inventarios && inventarios_charolas.includes(data.afecta_inventarios) &&
                    <div className='form-group bw-200 m-2'>
                        <label className='text-bold text-s w-100 text-start'>Cantidad de charolas</label>
                        <input type='number' className='form-control shadow border' min={0} name="charolas" value={cantidad.charolas} onChange={changeValue} />
                    </div>
                }
                {data.afecta_inventarios && inventarios_germinacion.includes(data.afecta_inventarios) &&
                    <div className='form-group bw-200 m-2'>
                        <label className='text-bold text-s w-100 text-start'>Germinación</label>
                        <input type='number' className='form-control shadow border' min={0} name="germinacion" value={cantidad.germinacion} onChange={changeValue} />
                    </div>
                }
                <div className='col-auto m-2'>
                    <label className='text-400 text-s w-100'>Pulse para agregar cantidad al inventario</label>
                    <button className='btn btn-warning border border-dark shadow round-xxl ps-5 pt-0 pb-0 pe-5 text-bold text-l'
                        disabled={cantidad.cantidad == 0}
                        onClick={registrar} >{cantidad.cantidad === 0 ? "Agregue la cantidad a registrar" : "Registrar"}</button>
                </div>
            </div>
        </div>
    )
}

export default RegistroActividadEjecutada;